<template>
  <AlertDialog>
    <TooltipProvider>
      <Tooltip :delay-duration="350">
        <TooltipTrigger as-child>
          <AlertDialogTrigger>
            <Icon v-if="!loading" name="mdi-arrow-left-top-bold" color="gray-200" />
            <Loader v-else class="w-6 p-1 text-gray-200" />
          </AlertDialogTrigger>
        </TooltipTrigger>
        <TooltipContent class="bg-primary text-sm">
          <FeedbackInformation :feedbacks="program.feedbacks!" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
    <AlertDialogContent @close-auto-focus="(e) =>e.preventDefault()">
      <AlertDialogHeader>
        <AlertDialogTitle>Réintégrer {{ consumer.information.first_name }} dans le programme ?</AlertDialogTitle>
        <AlertDialogDescription>
          Cette action réintègrera le patient dans le programme <strong>{{ program.name }}</strong>.
          Vous pourrez le masquer à nouveau si nécessaire.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel as-child class="!shadow-none">
          <BaseButton>Annuler</BaseButton>
        </AlertDialogCancel>
        <AlertDialogAction as-child>
          <BaseButton primary @click="deleteFeedback">
            Confirmer
          </BaseButton>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script lang="ts" setup>
import Icon from "@/core/components/icon/Icon.vue";
import {programApi} from "@/container";
import {
    AlertDialog,
    AlertDialogTrigger,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogFooter,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogAction,
    AlertDialogCancel
} from "@/core/components/ui/alert-dialog";
import Customer from "@/customer/interfaces/Customer";
import Beneficiary from "@/customer/interfaces/Beneficiary";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Tooltip, TooltipProvider, TooltipContent, TooltipTrigger} from "@/core/components/ui/tooltip";
import {Feedback, ProgramSnapshot} from "@/program/interfaces/Program";
import {usePatientStore} from "@/stores/patient.store";
import FeedbackInformation from "@/consumer/components/consumer-programs/FeedbackInformation.vue";
import {ref} from "vue";
import Loader from "@/core/components/base/spinner/Loader.vue";

const props = defineProps<{
    program: ProgramSnapshot;
    consumer: Customer | Beneficiary;
}>();

const patientStore = usePatientStore();

const loading = ref(false);

/**
 * Delete the program inclusion (in API).
 */
const deleteFeedback = async () => {
    loading.value = true;

    const promises = props.program.feedbacks?.map((feedback: Feedback) => {
        return programApi().deleteFeedback(props.program.id, feedback.id);
    });

    if (promises) {
        await Promise.all(promises);
    }

    await patientStore.refresh();

    loading.value = false;
};
</script>
